import React from 'react';
import { useParams } from 'react-router-dom';
import { StyleSheet, Text, View } from './components/base_components';
import StandardScreen from './components/standard_screen';

import BreadcrumbPath from './components/breadcrumb_path';
import ProgressSpinner from './components/progress_spinner';
import VolumeDirList from './components/volume_dir_list';
import VolumeFile from './components/volume_file';

import MediaStore from './stores/media_store';
import VolumeStore from './stores/volume_store';
import UserStore from './stores/user_store';

const styles = StyleSheet.create({
  volumeScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  spinner: {
    margin: '3rem',
    alignSelf: 'center',
  },
  dialog: {
    marginLeft: '2rem',
    marginBottom: '2rem',
    flexDirection: 'column',
  },
  text: {
    marginTop: '1em',
    fontSize: '1.5em',
  },
});

export default function VolumeScreen(props) {
  const params = useParams();
  const org = UserStore.useOrg();
  const volume_id = parseInt(params.volume_id ?? '0', 10) || 0;
  const path = '/' + (params['*'] ?? '');
  const volume = VolumeStore.useVolume(org?.org_id, volume_id);
  const has_access = VolumeStore.useVolumeAccess(org?.org_id, volume_id);
  const source_dir = MediaStore.useVolumeDirList(volume_id, path);
  const is_folder = path.endsWith('/');

  React.useEffect(() => {
    VolumeStore.fetch(org?.org_id);
  }, [org?.org_id]);
  React.useEffect(() => {
    MediaStore.fetchVolumeDir({ volume_id, path });
  }, [volume_id, path]);

  let content: any = null;
  if (has_access === false && org?.is_admin && volume) {
    content = (
      <View style={styles.dialog}>
        <Text style={styles.text}>
          Looks like you don't have access to this volume.
        </Text>
        <Text style={styles.text}>
          Edit your user and add access to this volume.
        </Text>
      </View>
    );
  } else if (has_access === false) {
    content = (
      <View style={styles.dialog}>
        <Text style={styles.text}>
          Looks like you don't have access to this volume.
        </Text>
        <Text style={styles.text}>
          Contract your organization's administrator to get access.
        </Text>
      </View>
    );
  } else if (!source_dir) {
    content = <ProgressSpinner style={styles.spinner} color='#555' />;
  } else if (is_folder) {
    content = (
      <VolumeDirList volume={volume} path={path} sourceDir={source_dir} />
    );
  } else if (path.toLowerCase() === source_dir.media_list?.[0]?.media_path?.toLowerCase?.()) {
    content = (
      <VolumeFile
        volumeId={volume_id}
        path={path}
        media={source_dir.media_list[0]}
      />
    );
  } else {
    content = (
      <VolumeFile
        volumeId={volume_id}
        path={path}
        media={null}
      />
    );
  }

  return (
    <View style={styles.volumeScreen}>
      <StandardScreen>
        {volume ? (
          <BreadcrumbPath
            volumeName={volume?.volume_name}
            prefix={`/volume/${volume_id}/`}
            path={path}
          />
        ) : null}
        {content}
      </StandardScreen>
    </View>
  );
}
